import { render, staticRenderFns } from "./LargeLoader.vue?vue&type=template&id=7290e004&scoped=true&"
var script = {}
import style0 from "./LargeLoader.vue?vue&type=style&index=0&id=7290e004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7290e004",
  null
  
)

export default component.exports